__turbopack_context__.v({
  "a": "Q6WZwG_a",
  "button": "Q6WZwG_button",
  "card": "Q6WZwG_card",
  "card-copy-content": "Q6WZwG_card-copy-content",
  "card-eyebrow": "Q6WZwG_card-eyebrow",
  "card-image": "Q6WZwG_card-image",
  "card-subtitle": "Q6WZwG_card-subtitle",
  "card-title": "Q6WZwG_card-title",
  "icon": "Q6WZwG_icon",
  "icon-container": "Q6WZwG_icon-container",
  "second-button-container": "Q6WZwG_second-button-container",
});
